import React from 'react'
import { NavLink } from 'react-router-dom'
import axios from 'axios'
import {useState,useEffect} from 'react'
function Attributes() {
  const HandleClickdelete = (Attributeid) => {
    axios.delete(process.env.REACT_APP_API_URL+`/api/Attribute/${Attributeid}`)
      .then((res) => {
        console.log(res);
        console.log(res.data);
        window.location.href = "/Attribute";
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const [Attribute,setAttribute] = useState([])
    useEffect(() => {
        axios
          .get(process.env.REACT_APP_API_URL+"/api/Attribute").then((res) => {setAttribute(res.data)}).catch((err) => {console.error(err);});
        });

  return (
    <>
    <section class="mx-auto w-full max-w-7xl px-4 py-4">
  <div class="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
    
    
  </div>
  <div className='flex justify-between mt-5 mr-2'>
    <h2 class="text-lg font-semibold">Attributes</h2>
    <NavLink to='/Attribute/CreateAttribute'><button className='rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black'>Create Attribute Groups</button></NavLink>
  </div>
  <br/>
  <div className='flex'>
    <select value='ALL'>
      <option value="All">ALL</option>
      <option value="FILTER"><input type="checkbox"/><span>Filter</span> </option>
      <option value="MY"><input type="checkbox"/><span>MY</span> </option>
      <option value="Active"><input type="checkbox"/><span>Active</span> </option>
      <option value="Delete"><input type="checkbox"/><span>Delete</span> </option>
    </select>
    <input 
    type="text" 
    placeholder="Search" 
    className="w-full px-3 py-2 border-b-2" 
  />
  <button type="submit" className="flex items-center justify-center w-auto px-4 py-2 bg-blue-500 text-white">
    <img  alt="Search" className="w-4 h-4"/>
  </button>
  </div>
  <br/>
  <div className="mt-6 flex flex-col">
    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div className="overflow-hidden border border-gray-200 md:rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-1 py-3.5 text-left text-sm font-normal text-gray-700">
                  <span><input type="checkbox" /> </span></th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  Attribute Name 
                </th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  Attribute type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  
                  Code 
                </th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  Attribute Group 
                </th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  Attribute Tab 
                </th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  Default Scope 
                  </th> 
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  Default Channel
                </th>
                <th scope="col" className="px-6 py-3 text-left text-sm font-normal text-gray-700">
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-sm font-normal text-gray-700">
                     </th>
                
                  </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                  {Attribute.map((Attribute) => (
                    <tr key={Attribute.id }>
                      <td className="px-1 py-4 whitespace-nowrap"> <input type='checkbox' className='w-5 h-5'/> </td>
                      <td>
                        <div className="flex items
                        -center pl-6">
                          {Attribute.attributename}
                        </div>
                      </td>
                      <td className="whitespace
                      -nowrap px-6 py-4">
                        <div className="text-sm text-gray-900 "> {Attribute.attributetype} </div>
                      </td>
                      <td class="whitespace
                      -nowrap px-6 py-4">
                        <div className="text-sm text-gray-900 "> {Attribute.code} </div>
                      </td>
                      <td class="whitespace-nowrap px-6 py-4">
                        <div className="text-sm text-gray-900 "> {Attribute.attributegroup} </div>
                      </td>
                      <td className="whitespace 
                      -nowrap px-6 py-4">
                        <div className="text-sm text-gray-900 "> {Attribute.attributetab} </div>
                      </td>
                      <td class="whitespace
                      -nowrap px-6 py-4">
                        <div className="text-sm text-gray-900 "> {Attribute.defaultscope} </div>
                      </td>
                      <td class="whitespace
                      -nowrap px-6 py-4">
                        <div className="text-sm text-gray-900 "> {Attribute.defaultchannel} </div>
                      </td>
                      <td class="whitespace
                      -nowrap px-6 py-4 text-right text-sm font-medium">
                        <NavLink to={`/Attribute/EditAttribute/${Attribute.id}`}> <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                          Edit
                        </button></NavLink>
                      </td>
                      <td class="whitespace
                      -nowrap px-6 py-4 text-right text-sm font-medium">
                        <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" onClick={()=>HandleClickdelete(Attribute.id)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                    </tbody>
                    </table>
                    </div>
                    </div>
                    </div>
                    </div>


  </section>
    </>
    
  )
}

export default Attributes